const city = document.querySelector(".city");
const buttons = document.querySelectorAll(".header__city");
const close = city.querySelector(".city__close");
const link = city.querySelector(".city__link");

buttons.forEach((button) => {
  button.addEventListener("click", (e) => {
    e.stopPropagation();
    city.classList.toggle("city_opened");

    if (city.classList.contains("city_opened")) {
      window.localStorage.removeItem("city");
    } else {
      window.localStorage.setItem("city", "true");
    }
  });
});

city.addEventListener("click", (e) => {
  e.stopPropagation();
});

document.addEventListener("click", () => {
  if (city.classList.contains("city_opened")) {
    city.classList.remove("city_opened");
    window.localStorage.setItem("city", "true");
  }
});

close.addEventListener("click", () => {
  city.classList.remove("city_opened");
  window.localStorage.setItem("city", "true");
});

link.addEventListener("click", () => {
  window.localStorage.setItem("city", "true");
});

document.addEventListener("DOMContentLoaded", () => {
  if (!window.localStorage.getItem("city")) {
    city.classList.add("city_opened");
  }
});
